import JobAppTermQueries from "./jobAppTerm/jobAppTerm.query";
import JobAppTermMutations from "./jobAppTerm/jobAppTerm.mutation";

const JobAppTermServices = {
  ...JobAppTermQueries,
  ...JobAppTermMutations,
};

export default JobAppTermServices;
